import {
  Injectable,
  RendererFactory2,
  ViewEncapsulation,
  Inject,
  PLATFORM_ID,
} from '@angular/core';
import { Router } from '@angular/router';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { environment } from '../../../../src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LinkService {
  renderer: any;

  constructor(
    private rendererFactory: RendererFactory2,
    private router: Router,
    @Inject(DOCUMENT) private document: any,
    @Inject(PLATFORM_ID) private platformid: any
  ) {
    this.renderer = this.rendererFactory.createRenderer(this.document, {
      id: '-1',
      encapsulation: ViewEncapsulation.None,
      styles: [],
      data: {},
    });
  }

  updateTag(tag: LinkDefinition) {
    this.removeTag(tag);
    this.addTag(tag);
  }

  updateCanonical(includeTrailingSlash = true) {
    let trailingSlash =
      includeTrailingSlash && this.router.url !== '/' ? '/' : '';
    let route =
      this.router.url.indexOf('/.') > -1
        ? this.router.url.substring(0, this.router.url.length - 2)
        : this.router.url;
    this.updateTag({
      rel: 'canonical',
      href: 'https://www.screenfortype1.com' + route + trailingSlash,
    });
  }

  /**
   * Rimuove il link esistente con lo stesso atrtributo rel
   */
  removeTag(tag: LinkDefinition) {
    try {
      const selector = this._parseSelector(tag);

      const canonical = this.document.querySelector(selector);
      const head = this.document.head;

      if (head === null) {
        throw new Error('<head> not found within DOCUMENT.');
      }
      if (!!canonical) {
        this.renderer.removeChild(head, canonical);
      }
    } catch (e) {
      console.error('Error within linkService : ', e);
    }
  }

  /**
   * Inietta il link ocme ultimo child del tag <head>
   */
  addTag(tag: LinkDefinition) {
    try {
      const link = this.renderer.createElement('link');
      const head = this.document.head;

      if (head === null) {
        throw new Error('<head> not found within DOCUMENT.');
      }

      Object.keys(tag).forEach((prop: string) => {
        return this.renderer.setAttribute(link, prop, tag[prop]);
      });

      // [TODO]: get them to update the existing one (if it exists) ?
      this.renderer.appendChild(head, link);
    } catch (e) {
      console.error('Error within linkService : ', e);
    }
  }

  private _parseSelector(tag: LinkDefinition): string {
    let selector = `link`;

    Object.keys(tag).forEach((prop: string) => {
      if (prop != 'href') selector += `[${prop}="${tag[prop]}"]`
    });

    return selector;
  }
}

export declare type LinkDefinition = {
  charset?: string;
  crossorigin?: string;
  href?: string;
  hreflang?: string;
  media?: string;
  rel?: string;
  rev?: string;
  sizes?: string;
  target?: string;
  type?: string;
} & {
  [prop: string]: string;
};
